import Config from 'services/config/config';
import callWebService, {callTypes} from 'services/utils/networks/network';
import {
  SITE_LISTING,
  SITE_FILTERS,
  VIEW_DETAILS,
  ASSIGNEE_LIST,
  SITE_ENABLE_DISABLE,
  SITE_PM_STATE_LIST, CONTRACT_DATA_FOR_RENEWAL, RENEWAL_LIST, RENEWAL_SAVE_RESPONSE, RENEWAL_BA_LISTING,HOTO_ASSIGNEE_LIST,
  BUSINESS_LIST,
  PLAN_LIST,
  FETCH_FILE_PLAN_UPLOAD,
  FETCH_INVOICE_DETAILS,
  SAVE_RENEWAL_CONTRACT
} from './type';
import {STATUS} from "../../../../constants/statusConstant";
import {ACCEPT, APPROVAL_LIST} from "../../approvals/salesApprovals/type";

export const getSiteListing = (filterData = null, page = 1) => async (
  dispatch
) => {
  dispatch({
    type: VIEW_DETAILS,
    payload: {},
  });
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.brandActivation.sitesListing}?page=${page}` : `${Config.brandActivation.sitesListing}?site_no=${filterData.site_no??''}&client_name=${filterData.client_name??''}&site_type=${filterData.site_type??''}&area_id=${filterData.area_id??''}&commercial_type_id=${filterData.commercial_type_id??''}&reporting_to=${filterData.reportingTo??''}&reportee=${filterData.reportee??''}&live_from_date=${filterData.live_from_date??''}&live_to_date=${filterData.live_to_date??''}&expiry_from_date=${filterData.expiry_from_date??''}&expiry_to_date=${filterData.expiry_to_date??''}&page=${page}`
  );
  if (res) {
    const {data} = res;
    dispatch({type: SITE_LISTING, payload: data.response.data});
    return data.response.data;
  }
};

export const UploadFlat = (info) => async (dispatch) => {
  const res = await callWebService(callTypes.post, info, Config.uploadFlat);
  if (res) {
    const {data} = res;
    if (data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const giveRating = (info) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    info,
    Config.brandActivation.giveRating
  );
  if (res) {
    const {data} = res;
    if (data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const getRating = (info) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getRating}?site_id=${info?.site_id}`
  );
  if (res) {
    const {data} = res;
    if (data?.response?.status === true) {
      return data.response.data;
    } else {
      return false;
    }
  }
};

export const getSiteFilters = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.brandActivation.siteFilters
  );
  if (res) {
    const {data} = res;
    dispatch({type: SITE_FILTERS, payload: data.response.data});
    return data.response.data;
  }
};

export const getDetails = (requestData) => async (dispatch) => {
  dispatch({
    type: VIEW_DETAILS,
    payload: {}
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.viewdetails}?lead_id=${requestData.lead_id}&site_id=${requestData.site_id}`
  );
  if (res?.data?.status_code === 403) {
    return null;
  }
  if (res?.data?.response?.status === true) {
    const {data} = res;
    dispatch({type: VIEW_DETAILS, payload: data.response.data});
    return true;
  }
};

export const getAssigneeList = (site_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.brandActivation.baReportees + `?site_id=${site_id}`
  );
  if (res) {
    const {data} = res;
    dispatch({type: ASSIGNEE_LIST, payload: data.response.data});
    return data.response.data;
  }
};

export const postAssignee = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.baChangeAssignee
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};

export const changeSiteState = (data) => async () => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.changeSiteStateToEnableOrDisable}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const changeSiteStateAsExpired = (data) => async () => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.changeSiteStateToExpired}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const changeSiteStateLegalEnable = (data) => async () => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.changeSiteStateEnableDispute}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const getSiteState = (siteId) => async (dispatch) => {
  dispatch({
    type: SITE_ENABLE_DISABLE,
    payload: '',
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getSiteStateToEnableOrDisable}?site_id=${siteId}`
  );
  if (res) {
    const {data} = res;
    dispatch({
      type: SITE_ENABLE_DISABLE,
      payload: data.response.data,
    });
    return true;
  }
};

export const getPmSiteState = (page) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getPmSiteStateList}?page=${page}`
  );
  if (res) {
    const {data} = res;
    dispatch({
      type: SITE_PM_STATE_LIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const updatePmSiteState = (data) => async () => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.updatePmSiteState}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};


export const getContractDataForRenewal = (siteId, isEdit=false) => async (dispatch) => {
  let apiUrl;
  if (isEdit) {
    apiUrl = `${Config.brandActivation.getContractDataForRenewal}?site_id=${siteId}&is_edit=1`
  } else {
    apiUrl = `${Config.brandActivation.getContractDataForRenewal}?site_id=${siteId}&is_edit=0`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${apiUrl}`
  );
  if (res) {
    const {data} = res;
    dispatch({
      type: CONTRACT_DATA_FOR_RENEWAL,
      payload: data.response.data,
    });
    return true;
  }
};

// export const renewalSaveData = (requestData) => async () => {
//   const res = await callWebService(
//     callTypes.post,
//     requestData,
//     Config.brandActivation.renewalSaveData
//   );
//   if (res?.data) {
//     if (res?.data.status_code == 500){
//       return false;
//     }
//     else if (res?.data?.status == false){
//       return false;
//     }
//     else{
//       return true;
//     }
      
   
//   } else {
//     return null;
//   }
// };

export const renewalSaveData = (requestData) => async (dispatch) => {

  let profileDetails = localStorage.getItem('profileDetails');
  let parsedProfileDetail = JSON.parse(profileDetails);
  let department_id = parsedProfileDetail[0].department_id;

  const updatedData = {
    ...requestData,
    department_id
  };

  const res = await callWebService(
      callTypes.post,
      updatedData,
      `${Config.brandActivation.renewalSaveData}`
  );
  if (!res?.data) {
    return false;
  }
  // V2: status 0 = success, 1 = error (e.g. "Another contract already pending…").
  // Do not treat a truthy axios response as success — that opened the success popup on business failures.
  const ok =
    res.data.status === true ||
    res.data?.response?.status === true ||
    res.data.status === 0;
  if (ok) {
    dispatch({
      type: SAVE_RENEWAL_CONTRACT,
      payload: res.data,
    });
    return true;
  }
  return false;
};

export const getRenewalApprovalList = (queryObj = null, page = 1) => async (
  dispatch
) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&page=${page}`;
  }

  const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
    .team_id;

  const departmentName = await JSON.parse(
    localStorage.getItem("profileDetails")
  )[0].department_id;

  let apiUrl;
  apiUrl = queryObj
    ? `${Config.brandActivation.getRenewalApprovalList}${filterQuery}`
    : Config.brandActivation.getRenewalApprovalList;

  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}?status=${STATUS.STATUS_APPROVE_PENDING}&page=${page}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    dispatch({type: RENEWAL_LIST, payload: payload?.data ?? outer?.data});
    return true;
  }
};

export const acceptRenewalApproval = (requestData) => async (dispatch) => {
  dispatch({type: ACCEPT, payload: null});
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.acceptRenewalApproval
  );
  if (res?.data?.response?.status === true) {
    const {data} = res;
    dispatch({type: "", payload: data.response.data});
    return true;
  }
};

export const rejectRenewalApproval = (requestData) => async (dispatch) => {
  dispatch({type: ACCEPT, payload: null});
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.rejectRenewalApproval
  );
  if (res?.data?.response?.status === true) {
    const {data} = res;
    dispatch({type: "", payload: data.response.data});
    return true;
  }
};

export const getRenewalListingList = (queryObj = null, page = 1) => async (
  dispatch
) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_type=${queryObj.site_type}&client_name=${queryObj.client_name}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.reportee}&area_id=${queryObj.area_id}`;
  }

  const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
    .team_id;

  const departmentName = await JSON.parse(
    localStorage.getItem("profileDetails")
  )[0].department_id;

  let apiUrl;
  apiUrl = queryObj
    ? `${Config.brandActivation.getRenewalListing}?page=${page}${filterQuery}`
    : `${Config.brandActivation.getRenewalListing}?page=${page}`;

  const res = await callWebService(
    callTypes.get,
    "",
    `${apiUrl}`
  );
  if (res) {
    const {data} = res;
    dispatch({type: RENEWAL_BA_LISTING, payload: data.response.data});
    return true;
  }
};

export const renewalSaveEditData = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.renewalSaveEditData
  );
  if (res?.data) {
    if (res?.data.status_code == 500) {
      return false;
    } else {
      return true;
    }
  } else {
    return null;
  }
};

export const getHotoAssigneeList = (team, site_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.maintenance.getHotoAssigneeList + `?site_id=${site_id}&team=${team}`
  );
  if (res) {
    const {data} = res;
    dispatch({type: HOTO_ASSIGNEE_LIST, payload: data.response.data});
    return data.response.data;
  }
};

export const updateHotoAssignee = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.maintenance.updateHotoSiteAssignee
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};

export const savePoc = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.savePoc
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};

export const businessListing = (page=1, filter = null) => async (dispatch) => {
  let url = Config.brandActivation.getBusinessList + `?page=${page}`
  if(filter !== null){
      url+= `&lead_id=${filter.leadID}&client_name=${filter.clientNameOrPartnerName}&assigned_to=${filter.leadOwnerOrAssignee}`
  }
  const res = await callWebService(
      callTypes.get,
      '',
      url
  );
  if (res) {
    const {data} = res;
    dispatch({type: BUSINESS_LIST, payload: data.response.data});
    return data.response.data;
  }
};

export const planListing = (page=1, filter = null) => async (dispatch) => {
  let url = Config.brandActivation.planListingDetails + `?page=${page}`
  if(filter !== null){
      url+= `&site_number=${filter.siteNumber}&agenda=${filter.agenda}&user_email=${filter.userEmail}&plan_date=${filter.planDate}&message=${filter.message}`
  }
  const res = await callWebService(
      callTypes.get,
      '',
      url
  );
  if (res) {
    const {data} = res;
    dispatch({type: PLAN_LIST, payload: data.response.data});
    return data.response.data;
  }
};


export const filePlanUploadListing = (filterData = null, page = 1) => async (
  dispatch
) => {
  dispatch({
    type: FETCH_FILE_PLAN_UPLOAD,
    payload: {},
  });
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.brandActivation.fetchUploadMeetingPlan}?page=${page}` : `${Config.brandActivation.fetchUploadMeetingPlan}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&area_id=${filterData.area_id}&commercial_type_id=${filterData.commercial_type_id}&reporting_to=${filterData.reportingTo}&reportee=${filterData.reportee}&page=${page}`
  );
  if (res) {
    const {data} = res;
    dispatch({type: FETCH_FILE_PLAN_UPLOAD, payload: data.response.data});
    return data.response.data;
  }
};


export const fetchInvoiceDetails = (request) => async (dispatch) => {
    const url = `${Config.brandActivation.getInvoiceDetails}?billing_start_date=${request?.billing_start_date}&contract_period=${request?.contract_period}&principal_amount=${request?.principal_amount}&payment_cycle=${request?.payment_cycle}`;

    const res = await callWebService(callTypes.get, '', url);
    
    if (res) {
      const outer = res.data;
      const payload = outer?.response ?? outer;
      const data = payload?.data ?? outer?.data;
      dispatch({ type: FETCH_INVOICE_DETAILS, payload: data });
      return data;
    }
};

